export default "__VITE_ASSET__C$5ma_$4__"